import React from 'react'
import "./Social.scss"
import {FaFacebook ,FaLinkedin} from 'react-icons/fa'
import{CgTwitter} from 'react-icons/cg'
import{BsGithub} from 'react-icons/bs'
import {motion} from 'framer-motion'



const scaleVariants = {
    whileInView: {
      scale: [0, 1],
      opacity: [0, 1],
      transition: {
        duration: 1,
        ease: 'easeInOut',
      },
    },
  };  
  
const Social = () => {
  return (
    <div 
 
    
        
    className='app__Social'>
        <div className='line-up'/>
        <motion.a
          whileInView={{ y: [-170, 0], opacity: [0, 1] }}
          transition={{ duration: 1 }}
          href="https://www.facebook.com/kais.manai"
        ><FaFacebook/></motion.a>
        <motion.a
         whileInView={{ y: [-170, 0], opacity: [0, 1] }}
         transition={{ duration: 1.5 }}
         href="https://twitter.com/kaismankais"
        ><CgTwitter/></motion.a>
        <motion.a
         whileInView={{ y: [-170, 0], opacity: [0, 1] }}
         transition={{ duration: 2 }}
         href="https://github.com/kaisman75/"
        ><BsGithub/></motion.a>
        <motion.a
         whileInView={{ y: [-170, 0], opacity: [0, 1] }}
         transition={{ duration: 2.5 }}
         href="https://www.linkedin.com/in/kais-manai-27827a8a/"
        ><FaLinkedin/></motion.a>
        <div className='line-down'/>
    </div>
  )
}

export default Social